/**
 * SELECTWINE business rule: one order may contain one bottle in total.
 *
 * This helper validates every Dawn Ajax cart path before it sends a mutation.
 * Shopify must still enforce the rule server-side for non-theme cart clients.
 */
window.SelectwineCartLimit = (() => {
  const message = '🚫 1품목 1병씩 구매 가능합니다 📦';
  let mutationReserved = false;

  async function fetchCart() {
    const response = await fetch(`${window.routes.cart_url}.js`, {
      headers: { Accept: 'application/json' },
    });

    if (!response.ok) throw new Error('Unable to validate the SELECTWINE cart limit.');
    return response.json();
  }

  async function reserveMutation(validate) {
    if (mutationReserved) return false;
    mutationReserved = true;

    try {
      const allowed = validate(await fetchCart());
      if (!allowed) mutationReserved = false;
      return allowed;
    } catch (error) {
      mutationReserved = false;
      throw error;
    }
  }

  function releaseMutation() {
    mutationReserved = false;
  }

  async function canAdd(quantity = 1) {
    const requestedQuantity = Number.parseInt(quantity, 10) || 1;
    return reserveMutation((cart) => requestedQuantity === 1 && cart.item_count === 0);
  }

  async function canChange(line, quantity) {
    const requestedQuantity = Number.parseInt(quantity, 10);
    return reserveMutation((cart) => {
      const currentItem = cart.items[Number.parseInt(line, 10) - 1];
      if (!currentItem || Number.isNaN(requestedQuantity)) return false;
      if (requestedQuantity === 0) return true;
      return requestedQuantity === 1 && cart.item_count - currentItem.quantity + requestedQuantity <= 1;
    });
  }

  async function canApplyUpdates(updates) {
    return reserveMutation((cart) => {
      const quantities = new Map(cart.items.map((item) => [item.key, item.quantity]));
      const keysByVariant = new Map(cart.items.map((item) => [String(item.id), item.key]));

      Object.entries(updates).forEach(([identifier, quantity]) => {
        const lineKey = quantities.has(identifier) ? identifier : keysByVariant.get(String(identifier)) || identifier;
        quantities.set(lineKey, Number.parseInt(quantity, 10) || 0);
      });

      const totalQuantity = Array.from(quantities.values()).reduce((total, quantity) => total + quantity, 0);
      return totalQuantity <= 1;
    });
  }

  function lockProductQuantity(input) {
    input.max = '1';
    if ((Number.parseInt(input.value, 10) || 1) > 1) input.value = '1';
    const plusButton = input.closest('quantity-input')?.querySelector('[name="plus"]');
    if (plusButton) plusButton.disabled = true;
  }

  function lockProductQuantities(root = document) {
    root.querySelectorAll('input[name="quantity"][form*="product-form"]').forEach(lockProductQuantity);
  }

  document.addEventListener('DOMContentLoaded', () => lockProductQuantities(), { once: true });
  document.addEventListener('shopify:section:load', (event) => lockProductQuantities(event.target));
  document.addEventListener('change', (event) => {
    if (event.target.matches('input[name="quantity"][form*="product-form"]')) lockProductQuantity(event.target);
  });

  return { message, canAdd, canChange, canApplyUpdates, releaseMutation };
})();
